import { axiosInstance } from "./axiosInstance";

export const treatmentService = {
    getTreatment: async ( filters ) => {
        return await axiosInstance.get('/api/superadmin/treatment', { params: filters })
    },
    createTreatment: async (data) => {
        return await axiosInstance.post('/api/superadmin/treatment/create', data)
    },
    updateTreatment: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/treatment/update/${id}`, data)
    },
    deleteTreatment: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/treatment/delete/${id}`)
    },
    deletePhotos: async (pivotId) => {
        return await axiosInstance.delete(`/api/superadmin/treatment/delete-photos/${pivotId}`)
    }
}
